class Spinner {
    constructor(button) {
        this.button = button
        this.targetId = button.dataset.spinnerDecrease || button.dataset.spinnerIncrease
        this.input = document.getElementById(this.targetId)
        
        if (!this.targetId || !this.input) return
        
        button.addEventListener('click', this.handleClick.bind(this))
        
        this.updateButtonState()
        
        this.input.addEventListener('input', this.updateButtonState.bind(this))
        this.input.addEventListener('change', this.updateButtonState.bind(this))
    }
    
    handleClick(e) {
        e.preventDefault()
        
        try {
            if (this.button.dataset.spinnerIncrease) {
                this.input.stepUp()
            } else if (this.button.dataset.spinnerDecrease) {
                this.input.stepDown()
            }
            
            // Dispatch events to notify other parts of the application
            this.input.dispatchEvent(new Event('blur'))
            this.input.dispatchEvent(new Event('change', { bubbles: true }))
            this.input.dispatchEvent(new Event('input', { bubbles: true }))
            
        } catch (error) {
            // stepUp/stepDown throw errors when they can't execute (e.g., at min/max)
            // We can silently ignore these or handle them as needed
            console.debug('Step operation failed:', error.message)
        }
        
        this.updateButtonState()
    }
    
    updateButtonState() {
        const max = this.input.max ? parseInt(this.input.max) : Infinity
        const min = this.input.min ? parseInt(this.input.min) : -Infinity
        const currentValue = parseInt(this.input.value) || 0
        
        if (this.button.dataset.spinnerIncrease) {
            this.button.disabled = currentValue >= max
        } else if (this.button.dataset.spinnerDecrease) {
            this.button.disabled = currentValue <= min
        }
    }
}

export default Spinner